import React from 'react'

export default function BoxLoader() {
    return (
        <div className='box-loader'>
            <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
    )
}
